import { IWebClient } from "@cd2/skeem-client"
import { IRecord } from "../../types/schema"

export async function fetchOrderRequestBranchAssoc(
  skeem: IWebClient,
  sourceBranchId: string,
  targetBranchId: string,
) {
  return await skeem.fetch2<
    IRecord<"orderRequestBranches", "customer" | "sourceBranch" | "targetBranch"> & {
      supplier: IRecord<"suppliers", "currency_name">
      billingAddress: IRecord<
        "addresses",
        | "name"
        | "line_1"
        | "line_2"
        | "line_3"
        | "line_4"
        | "city"
        | "county"
        | "country"
        | "postcode"
        | "phone"
        | "email"
      >
      shippingAddress: IRecord<
        "addresses",
        | "name"
        | "line_1"
        | "line_2"
        | "line_3"
        | "line_4"
        | "city"
        | "county"
        | "country"
        | "postcode"
        | "phone"
        | "email"
      >
    }
  >({
    first: {
      name: "orderRequestBranches",
      attributes: [
        "sourceBranch",
        "targetBranch",
        "customer",
        { name: "supplier", attributes: ["currency_name"] },
        {
          name: "billingAddress",
          attributes: [
            "name",
            "line_1",
            "line_2",
            "line_3",
            "line_4",
            "city",
            "county",
            "country",
            "postcode",
            "phone",
            "email",
          ],
        },
        {
          name: "shippingAddress",
          attributes: [
            "name",
            "line_1",
            "line_2",
            "line_3",
            "line_4",
            "city",
            "county",
            "country",
            "postcode",
            "phone",
            "email",
          ],
        },
      ],
      filter: {
        matches: {
          sourceBranch: sourceBranchId,
          targetBranch: targetBranchId,
        },
      },
    },
  })
}
